export const mapLinks = ({ link }) => ({
  id: link.id,
  name: link.name,
  lastUpdate: link.lastUpdate,
  status: link.status,
  providerTicker: link.venueTicker,
  providerName: link.venueName,
})
